import { render, staticRenderFns } from "./gantt-pagination.vue?vue&type=template&id=d4b2bf16&scoped=true&"
import script from "./gantt-pagination.component.ts?vue&type=script&lang=ts&"
export * from "./gantt-pagination.component.ts?vue&type=script&lang=ts&"
import style0 from "./gantt-pagination.scss?vue&type=style&index=0&id=d4b2bf16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b2bf16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4b2bf16')) {
      api.createRecord('d4b2bf16', component.options)
    } else {
      api.reload('d4b2bf16', component.options)
    }
    module.hot.accept("./gantt-pagination.vue?vue&type=template&id=d4b2bf16&scoped=true&", function () {
      api.rerender('d4b2bf16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/last-mile-delivery-wellcome/components/gantt-pagination/gantt-pagination.vue"
export default component.exports